import React, { useContext, useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useMemo } from 'react';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import ClientSideDataRender from '../ReportsScreens/GijgoForReportsScreen/ClientSideGridData';
import { Grid, InputLabel, FormHelperText } from '@material-ui/core';
import { DatePicker, SecondaryButton, SingelSelect } from '../../../Core/FormInput';
import AppContext from '../../../App/AppContext';
import { getVHCItem_Dropdown, getVHCItems } from '../../../Core/Service/vhc-service';
import TechWriteUp from '../../../Components/technician/technician-app/TechWriteUp';
import debounce from 'lodash/debounce';
import moment from 'moment';
import DialogComp from '../../../Core/Controls/Dialog/DialogComp';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'VHC', active: true }
];

const basecolumns = [
    { field: 'registration', title: 'Registration', width: 30, filterable: true },
    { field: 'wipNumber', title: 'WIP Number', width: 20, filterable: true },
    { field: 'advisory', title: 'VHC Item', width: 80, filterable: true },
    { field: 'vhcLevelText', title: 'Condition', width: 30, filterable: true },
    { field: 'dateCreated', title: 'Date Created', width: 30, filterable: true },
    { field: 'customer', title: 'Customer', width: 70, filterable: true }
];

const VHC = () => {
    const { showToast } = useContext(AppContext);
    const [openTechDialog, setOpenTechDialog] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [state, setState] = useState({
        showLoader: false,
        branch: null,
        vhcValue: null,
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        errors: {},
        branches: [],
        vhcItemTypes: [],
        url: null
    });
    const debouncedSubmit = useRef(debounce((fn) => fn(), 500)).current;

    const handleVHCClick = (record) => {
        setSelectedRecord(record);
        setOpenTechDialog(true);
    };

    const RegColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const url = `/Job/${record.headerRecordID}/${record.workflowID}?ProcessId=${record.workflowProcessId}`;
        const lnk = (
            <Grid container alignItems="center">
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline',
                        color: 'inherit'
                    }}
                >
                    {value}
                </a>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const VHCItemColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline',
                        color: 'inherit'
                    }}
                    onClick={() => handleVHCClick(record)}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const column = useMemo(() => {
        let col = [...basecolumns];
        let colReg = col.find((m) => m.field === 'registration');
        if (colReg) {
            colReg.renderer = RegColumnWrapper;
        }
        let colVHCitem = col.find((m) => m.field === 'advisory');
        if (colVHCitem) {
            colVHCitem.renderer = VHCItemColumnWrapper;
        }

        return col;
    }, []);

    const handleSingleSelect = (name) => (ev, val) => {
        setState((st) => ({ ...st, [name]: val }));
    };

    const handleDateChange = (name) => (e) => {
        const value = e.target.value;
        setState((st) => ({
            ...st,
            [name]: value,
            errors: { ...st.errors, [name]: null }
        }));
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await getVHCItem_Dropdown();
                if (response.success) {
                    setState((st) => ({
                        ...st,
                        branches: response.data.branches,
                        vhcItemTypes: response.data.vhcItemTypes,
                        showLoader: false
                    }));
                }
            } catch {
                showToast('Failed to fetch initial data', 'error');
                setState((st) => ({ ...st, showLoader: false }));
            }
        })();
    }, []);

    const fetchData = async () => {
        const errors = {};
        if (!state.branch) errors.branch = "Company can't be empty";
        if (!state.startDate) errors.startDate = "Start Date can't be empty";
        if (!state.endDate) errors.endDate = "End Date can't be empty";

        if (state.startDate && state.endDate) {
            const start = new Date(state.startDate);
            const end = new Date(state.endDate);
            if (start > end) errors.endDate = 'End date cannot be before start date';
        }

        if (Object.keys(errors).length) {
            setState((st) => ({ ...st, errors, showLoader: false }));
            return;
        }

        setState((st) => ({ ...st, showLoader: true }));
        try {
            const res = await getVHCItems({
                companyId: state.branch.id,
                startDate: state.startDate,
                endDate: state.endDate,
                vhcValueId: state.vhcValue?.id
            });

            if (res.success) {
                let dataList = res.data.list || [];
                if (state.vhcValue) {
                    dataList = dataList.filter((item) => item.vhcLevelText === state.vhcValue.name);
                }

                setState((st) => ({
                    ...st,
                    fullList: res.data.list,
                    list: dataList,
                    isReload: new Date().getTime(),
                    showLoader: false,
                    errors: {}
                }));
            }
        } catch (error) {
            console.error('API Error:', error);
            showToast('Failed to fetch VHC data', 'error');
            setState((st) => ({ ...st, showLoader: false }));
        }
    };

    useEffect(() => {
        if (state.fullList?.length > 0) {
            let filteredData = state.fullList;

            if (state.vhcValue) {
                filteredData = state.fullList.filter((item) => item.vhcLevelText === state.vhcValue.name);
            }

            setState((st) => ({
                ...st,
                list: filteredData,
                isReload: new Date().getTime()
            }));
        }
    }, [state.vhcValue, state.fullList]);

    useEffect(() => {
        if (state.branch && state.startDate && state.endDate) {
            debouncedSubmit(fetchData);
        }
    }, [state.branch, state.startDate, state.endDate]);

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1} style={{ marginTop: 3 }}>
                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink className="mandatoryfields" required style={{ marginBottom: -8 }}>
                        Branch
                    </InputLabel>
                    <SingelSelect options={state.branches} value={state.branch} onChange={handleSingleSelect('branch')} />
                    <FormHelperText error={!!state.errors.branch}>{state.errors.branch}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                    <InputLabel className="mandatoryfields" required shrink style={{ marginBottom: -7 }}>
                        Start Date
                    </InputLabel>
                    <DatePicker
                        style={{ marginTop: 8 }}
                        placeholder="Start Date"
                        fullWidth
                        name="startDate"
                        value={state.startDate}
                        onChange={handleDateChange('startDate')}
                    />
                    {state.errors?.startDate && <FormHelperText error>{state.errors.startDate}</FormHelperText>}
                </Grid>

                <Grid item xs={12} sm={6} md={2}>
                    <InputLabel className="mandatoryfields" required shrink style={{ marginBottom: -7 }}>
                        End Date
                    </InputLabel>
                    <DatePicker
                        style={{ marginTop: 8 }}
                        placeholder="End Date"
                        fullWidth
                        name="endDate"
                        value={state.endDate}
                        onChange={handleDateChange('endDate')}
                    />
                    {state.errors?.endDate && <FormHelperText error>{state.errors.endDate}</FormHelperText>}
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <InputLabel shrink style={{ marginBottom: -8 }}>
                        VHC Value
                    </InputLabel>
                    <SingelSelect options={state.vhcItemTypes} value={state.vhcValue} onChange={handleSingleSelect('vhcValue')} />
                </Grid>
            </Grid>

            {state.showLoader ? (
                <div style={{ padding: 20, textAlign: 'center' }}>Loading...</div>
            ) : state.branch && state.startDate && state.endDate ? (
                <ClientSideDataRender
                    dataConverter={() => state.list || []}
                    columns={column}
                    renderClientSideData={true}
                    displayPagination={true}
                    isReload={state.isReload}
                />
            ) : (
                <div
                    style={{
                        padding: '40px 20px',
                        textAlign: 'center',
                        color: '#666',
                        fontSize: '1.2rem',
                        border: '1px dashed #ddd',
                        margin: '20px'
                    }}
                >
                    Please select Branch, Start Date, and End Date to view results
                </div>
            )}

            {openTechDialog && selectedRecord && (
                <DialogComp open={openTechDialog} onClose={() => setOpenTechDialog(false)} maxWidth="xl" fullScreen overflow>
                    <TechWriteUp
                        headerRecordID={selectedRecord.headerRecordID}
                        fromstep={false}
                        location={{ search: `?fromstep=false` }} 
                        isTechReadonly="Y"
                        onSuccess={() => setOpenTechDialog(false)}
                    />
                </DialogComp>
            )}
        </div>
    );
};

export default VHC;
